import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase/app";
import "firebase/firestore";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/AuthView.vue"),
    meta: { requiresGuest: true }
  },
  {
    path: "/invitation/:invitationId",
    name: "invitation",
    props: true,
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/AuthView.vue")
  },
  {
    path: "/referral/:referralCode",
    name: "referral",
    props: true,
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/AuthView.vue")
  },
  {
    path: "/help",
    name: "help",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/Help.vue")
  },
  {
    path: "/profile",
    name: "profile",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Profile.vue")
  },
  {
    path: "/profile/delete",
    name: "deleteAccount",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DeleteAccount.vue")
  },
  {
    path: "/profile/:status",
    name: "profileStatus",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Profile.vue")
  },
  {
    path: "/events",
    name: "events",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Events.vue")
  },
  {
    path: "/events/choose/",
    name: "chooseEventType",
    //props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/EventType.vue")
  },
  {
    path: "/events/create/",
    name: "createEvent",
    //props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreateEvent.vue")
  },
  {
    path: "/events/event/:id",
    name: "editEvent",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreateEvent.vue")
  },
  {
    path: "/events/preview/:id",
    name: "previewEvent",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/EventPreview.vue")
  },
  {
    path: "/events/summary/:id",
    name: "eventSummary",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/EventSummary.vue")
  },
  {
    path: "/festivals/create/",
    name: "createFestival",
    //props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreateFestival.vue")
  },
  {
    path: "/festivals/:festivalId/season/:seasonId",
    name: "editFestival",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreateFestival.vue")
  },
  {
    path: "/festivals/:festivalId/seasonSummary/:seasonId",
    name: "festivalSummary",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FestivalSummary.vue")
  },
  {
    path: "/festivalEvents/event/:id",
    name: "editFestivalEvent",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FestivalEvent.vue")
  },
  {
    path: "/festival/preview/:festivalId/:seasonId",
    name: "previewFestival",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FestivalPreview.vue")
  },
  {
    path: "/eventseries/create/",
    name: "createEventSeries",
    //props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreateEventSeries.vue")
  },
  {
    path: "/eventseries/:id",
    name: "editEventSeries",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CreateEventSeries.vue")
  },
  {
    path: "/eventseries/summary/:id",
    name: "seriesSummary",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeriesSummary.vue")
  },
  {
    path: "/eventseries/preview/:id",
    name: "previewSeries",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SeriesPreview.vue")
  },
  {
    path: "/festivals/:festivalId/seasonSummary/:id",
    name: "festivalSummary",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FestivalSummary.vue")
  },
  {
    path: "/events/summary/:eventId/performance/:id",
    name: "performanceSummary",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PerformanceSummary.vue")
  },
  {
    path: "/willcall/:eventId/performance/:id",
    name: "willcall",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Willcall.vue")
  },
  {
    path: "/venues",
    name: "venues",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Venues.vue")
  },
  {
    path: "/event/published",
    name: "eventPublished",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/EventPublished.vue")
  },
  {
    path: "/eventseries/published",
    name: "eventSeriesPublished",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/EventSeriesPublished.vue"
      )
  },
  {
    path: "/optins",
    name: "optins",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Optins.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/AuthView.vue"),
    meta: { requiresGuest: true }
  },
  {
    path: "/signup",
    name: "signup",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../views/AuthView.vue"),
    meta: { requiresGuest: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  // Wait for auth state to be resolved
  await new Promise(resolve => {
    const unsubscribe = firebase.auth().onAuthStateChanged(() => {
      unsubscribe();
      resolve();
    });
  });

  const currentUser = firebase.auth().currentUser;
  const isAuthenticated = store.getters["user/isAuthenticated"];

  // Public routes that don't require authentication
  const publicRoutes = [
    "home",
    "invitation",
    "referral",
    "help",
    "signup",
    "login"
  ];

  // Routes that require user to be logged out
  const guestOnlyRoutes = to.meta?.requiresGuest;

  if (guestOnlyRoutes && (currentUser || isAuthenticated)) {
    // Redirect authenticated users away from login page
    next({ name: "events" });
    return;
  }

  // Redirect authenticated users from home page to events
  if (to.name === "home" && (currentUser || isAuthenticated)) {
    next({ name: "events" });
    return;
  }

  if (!publicRoutes.includes(to.name) && !currentUser && !isAuthenticated) {
    // Store the intended route for redirect after login
    if (to.path !== "/login" && to.path !== "/signup") {
      localStorage.setItem("gobo_redirect_after_login", to.fullPath);
    }
    next({ name: "login" });
    return;
  }

  next();
});

export default router;
